import { render } from "./EmailBodyEditor.vue?vue&type=template&id=7447abd8"
import script from "./EmailBodyEditor.vue?vue&type=script&lang=js"
export * from "./EmailBodyEditor.vue?vue&type=script&lang=js"

import "./EmailBodyEditor.vue?vue&type=style&index=0&id=7447abd8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__